import { useLocation } from "react-router-dom";
import { Header } from "@/components/portfolio/Header";
import { BackToTop } from "@/components/ui/BackToTop";
import { useEffect } from "react";

export function AppLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";

  // Pages that should not show the header
  const hideHeader = [
    "/sign-in",
    "/sign-up",
    "/auth",
  ].some((path) => location.pathname.startsWith(path));

  // Landing page and store have their own footer
  const hasOwnFooter = [
    "/",
  ].includes(location.pathname);

  return (
    <div className={`min-h-screen bg-slate-50 ${isLandingPage ? "homepage-notion" : ""}`}>
      {/* Global Header */}
      {!hideHeader && <Header />}

      {/* Main Content */}
      <main>
        {children}
      </main>

      {/* Back to Top */}
      <BackToTop />
    </div>
  );
}
